module.exports = __webpack_public_path__ + "static/media/22_plantilla_combo_cuadrada_marco_comida_29.e7d2219b.png";